// Normalising choir song titles. One song must always end up under the same
// document, however it was typed: "Wie groß  bist du", " wie Groß bist du "
// and "Wie groß bist du" are the same song.
//
// This file exists twice with identical content – functions/src/songTitle.ts
// and src/utils/songTitle.ts – because frontend and Cloud Functions cannot
// share source files. Both run against the cases in
// src/utils/songTitle.cases.json, and a test compares the two files.

/** The title as it is displayed: trimmed, runs of whitespace collapsed. */
export function normalizeSongTitle(title: string): string {
    return String(title ?? "").normalize("NFC").replace(/\s+/g, " ").trim();
}

/**
 * The Firestore document id of a song: the display title with "/" replaced
 * (a slash would start a sub-path). Upper and lower case are kept.
 */
export function songDocId(title: string): string {
    const id = normalizeSongTitle(title).replace(/\//g, "_");
    // Firestore rejects ".", ".." and ids of the form __x__.
    if (id === "." || id === ".." || /^__.*__$/.test(id)) return `_${id}`;
    return id;
}

/** The key two titles are compared by: the document id, ignoring case. */
export function songKey(title: string): string {
    return songDocId(title).toLowerCase();
}

/** True when both titles mean the same song. */
export function isSameSong(a: string, b: string): boolean {
    return songKey(a) === songKey(b);
}
